import {
    ADDRESS_FIELDS_FRAGMENT,
    COUNTRY_FIELDS_FRAGMENT,
    DISCOUNT_FIELDS_FRAGMENT,
    DISCOUNT_COUPON_FIELDS_FRAGMENT,
    ORDER_FIELDS_FRAGMENT,
    PAYMENT_GATEWAY_FIELDS_FRAGMENT,
    COURIER_FIELDS_FRAGMENT
} from "./fragments";

export const GET_ORDER = /* GraphQL */ `
    ${ORDER_FIELDS_FRAGMENT}
    query GetOrder($data: GetOrderInput!) {
        getOrder(data: $data) {
            ...OrderFields
        }
    }
`;
export const GET_CART_SUGGESTED_PRODUCTS = /* GraphQL */ `
    mutation GetCartSuggestedProducts($data: GetCartSuggestedProductsInput!) {
        getCartSuggestedProducts(data: $data) {
            product
            addedProduct
            SKUName
            SKUCode
            imageUrl
            currentPrice
        }
    }
`;
export const GET_CUSTOMER = /* GraphQL */ `
    query GetCustomer($id: ID!) {
        getCustomer(id: $id) {
            id
            firstName
            lastName
            email
            phoneNumber
        }
    }
`;
export const GET_LOGGED_IN_CUSTOMER = /* GraphQL */ `
    query getLoggedInCustomerData {
        getLoggedInCustomerData {
            id
            firstName
            lastName
            email
            phoneNumber
            creditAmountTotal
            referralCode
        }
    }
`;

export const GET_CUSTOMER_BY_EMAIL = /* GraphQL */ `
    query GetCustomerByEmail($salesChannel: String!, $email: String!, $tenant: String!) {
        getCustomerByEmailSalesChannel(
            email: $email
            salesChannel: $salesChannel
            tenant: $tenant
        ) {
            data {
                id
                firstName
                lastName
                email
                phoneNumber
                cognitoUser
                salesChannel
            }
        }
    }
`;
export const SHIPPING_METHOD_FIELDS_FRAGMENT = /* GraphQL */ `
    fragment ShippingMethodFields on ShippingMethod {
        id
        name
        freeOver
        imageUrl
    }
`;

export const GET_SHIPPING_METHODS = /* GraphQL */ `
    ${SHIPPING_METHOD_FIELDS_FRAGMENT}
    query GetShippingMethods($tenant: String) {
        getShippingMethods(tenant: $tenant) {
            data {
                ...ShippingMethodFields
            }
        }
    }
`;

export const GET_PRODUCT_TAX_CODES_DATA = /* GraphQL */ `
    query GetProductTaxCodesData($id: String!, $tenant: String) {
        getProductTaxCodesData(id: $id, tenant: $tenant) {
            id
            product
            taxCode
            name
            taxRate
            countryCodeRegex
            notCountryCodeRegex
            stateCodeRegex
            notStateCodeRegex
            zipCodeRegex
            notZipCodeRegex
        }
    }
`;

export const GET_PRODUCT = /* GraphQL */ `
    query GetProduct($id: String!, $tenant: String) {
        getProduct(id: $id, tenant: $tenant) {
            id
            productType
            SKUCode
            SKUName
            reviewSKU

            currentPrice
            listPrice

            shortName
            shortDescription
            fullDescription
            unitOfMeasure
            weight
            nettWeight
            weightMeasure
            width
            height
            depth
            imageUrl
            presaleLimit
            bundle
            schema
            metadata
        }
    }
`;
export const GET_PRODUCT_DATA = /* GraphQL */ `
    query GetProductData($id: String!, $tenant: String, $salesChannel: String) {
        getProductData(id: $id, tenant: $tenant, salesChannel: $salesChannel) {
            currentPrice
            listPrice
            stock {
                text
                type
                color
                fontColour
                presaleDate
            }
        }
    }
`;

export const GET_CUSTOMER_ORDERS = /* GraphQL */ `
    ${ORDER_FIELDS_FRAGMENT}
    query GetCustomerOrders($data: GetCustomerOrdersInput!) {
        getCustomerOrders(data: $data) {
            ...OrderFields
        }
    }
`;
export const GET_MY_ADDRESSES = /* GraphQL */ `
    ${ADDRESS_FIELDS_FRAGMENT}
    query GetMyAddresses {
        getMyAddresses {
            ...AddressFields
        }
    }
`;
export const GET_ORDERS = /* GraphQL */ `
    ${ORDER_FIELDS_FRAGMENT}
    query GetOrders($data: GetOrdersInput!) {
        getOrders(data: $data) {
            ...OrderFields
        }
    }
`;

export const LIST_PAYMENT_GATEWAYS = /* GraphQL */ `
    ${PAYMENT_GATEWAY_FIELDS_FRAGMENT}
    query GetPaymentGateways($tenant_id: String) {
        getPaymentGatewaysForWebsite(tenant_id: $tenant_id) {
            data {
                ...PaymentGatewayFields
            }
        }
    }
`;
export const GET_PAYMENT_GATEWAY_BY_TYPE = `
    ${PAYMENT_GATEWAY_FIELDS_FRAGMENT}
    query GetPaymentGatewayByType($type: String) {
        paymentGateways {
            getPaymentGatewayByType(type: $type) {
                ...PaymentGatewayFields
            }
        }
    }
`;

export const GET_COUNTRIES = `
  ${COUNTRY_FIELDS_FRAGMENT}
  query GetCountries($tenant:String){
      getCountries(tenant:$tenant){
        data {
          ...CountryFields
        }
      }
    }

`;
export const GET_CURRENCY_CODES = `
  query GetCurrencyCodes($tenant:String){
      getCurrencyCodes(tenant:$tenant){
        data {
            id
            name
            currencyCode
            formatString
            roundTo
            isBase
        }
    }
  }
`;

export const GET_COURIER = `
  ${COURIER_FIELDS_FRAGMENT}
  query GetCourier($id: String!, $tenant:String) {
      getCourier(id: $id,tenant:$tenant) {
        ...CourierFields
      }
  }
`;

export const GET_REVIEWS = /* GraphQL */ `
    query GetReviews($salesChannel: String!, $limit: String, $nextToken: String, $tenant: String) {
        getReviews(
            salesChannel: $salesChannel
            limit: $limit
            nextToken: $nextToken
            tenant: $tenant
        ) {
            data {
                id
                title
                author
                body
                ratingValue
                datePublished
                type
                customerName
                customer
                order
                product
                externalRef
            }
        }
    }
`;

export const GET_REVIEWS_BY_SKU = /* GraphQL */ `
    query GetReviewsBySKU($sku: String, $tenant: String) {
        getReviewsBySKU(SKUCode: $sku, tenant: $tenant) {
            id
            title
            author
            body
            ratingValue
            datePublished
            product
            externalRef
            productId
        }
    }
`;
